mutation RegisterAttendees(
  $eventId: ID!
  $lead: AttendeeDetailsInput!
  $plusOnes: [AttendeeDetailsInput!]
  $target: RegistrationTargetEnum
  $notify: Boolean
) {
  registerAttendees(
    input: {
      eventId: $eventId
      lead: $lead
      plusOnes: $plusOnes
      target: $target
      notify: $notify
    }
  ) {
    state
    registration {
      id
    }
  }
}
